import { z } from 'zod';

export const statusSchema = z.object({
  version: z.string(),
  buildTime: z.string(),
  gitHash: z.string(),
});
